import BaseModule from "./base-module";

class Delivery extends BaseModule {
    getDeliveryCategory(params) {
        return this.get("/customer/v1/commoditycategory", {params});
    }

    getDeliveryCategory2(params) {
        return this.get("/customer/v1/commodity/category", {params});
    }

    getDeliveries(params) {
        return this.get("/customer/v1/commodity/all", {
            params: {
                ...params,
                type: params.buffet ? 2 : 0
            }
        });
    }

    getDeliveryDetail(params) {
        return this.get("/customer/v1/commodity/details", {params});
    }
}

export default new Delivery();
